import { BodyText, Card, Strong } from '@utilitywarehouse/hearth-react';
import { Heading } from '@utilitywarehouse/hearth-react';
import { TickSmallIcon } from '@utilitywarehouse/hearth-react-icons';

import { BundleBenefit, BundleBenefits } from '@generated/gql/graphql';

import './styles.scss';

const Benefit = ({ emphasisedText, unemphasisedText }: BundleBenefit) => (
  <li className="bundle-benefits__list-item">
    <TickSmallIcon />
    <BodyText>
      <Strong>{emphasisedText}</Strong> {unemphasisedText}
    </BodyText>
  </li>
);

const BundleBenefitsTile = ({
  coreServiceCount: coreServiceCountText,
  benefits,
}: BundleBenefits) => {
  if (!benefits || benefits.length === 0) {
    return null;
  }

  const nonEmptyBenefits = benefits.filter(Boolean);

  if (nonEmptyBenefits.length === 0) {
    return null;
  }

  return (
    <Card className="bundle-benefits__wrapper">
      <Heading as="h3" size="md">
        By bundling {coreServiceCountText}{' '}
        {coreServiceCountText === 'one' ? 'service' : 'services'}, you've also
        unlocked...
      </Heading>
      <ul className="bundle-benefits__list">
        {nonEmptyBenefits.map((benefit) => (
          <Benefit
            key={benefit.emphasisedText + benefit.unemphasisedText}
            {...benefit}
          />
        ))}
      </ul>
    </Card>
  );
};

export { BundleBenefitsTile };
